module.exports = __webpack_public_path__ + "img/logo-footer.4c2987d1.png";